<template>
<div>
    <div class="dg-backdrop"></div>
    <div class="dg-container dialog-container">
        <div class="dg-content-cont dg-content-cont--floating">
            <div class="dg-main-content">
                <div class="dg-view-wrapper">
                    <div class="dg-content-body">
                        <div class="dg-title">
                            <h6>{{ dialogParams.cardInfoDialog.title }}</h6>
                        </div>
                        <div :class="'dg-content' + (loadingIndicator ? ' loading' : ' card-body')">
                            <div v-if="loadingIndicator" class="page-loading-indicator">
                                <img src="/images/eowp/animation/loading-spinner.jpg" />
                                <div class="loading-message"> {{ dialogParams.loadingDialog.message }}</div>
                            </div>
                            <div v-else>
                                <div :class="getCardBrandIcon(eowp.subscriptionInfo.type)"></div>
                                <div class="cardNumber"><span class="hidden-number">&#9679;&#9679;&#9679;&#9679; &#9679;&#9679;&#9679;&#9679; &#9679;&#9679;&#9679;&#9679; </span>  {{ eowp.subscriptionInfo.refId }}</div>
                                <div class="info-row">
                                    <div class="name"><span class="label">{{ dialogParams.cardInfoDialog.label.name }} <br /></span>{{ eowp.subscriptionInfo.name }}</div>
                                    <div class="expiry"><span class="label">{{ dialogParams.cardInfoDialog.label.expiry }} <br /></span>{{ eowp.subscriptionInfo.month }} / {{ eowp.subscriptionInfo.year }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="dg-content-footer">
                        <button class="dg-btn dg-btn--cancel dg-pull-right" @click="closeDialog()">
                            <span class="dg-btn-content">
                                {{ dialogParams.cardInfoDialog.closeText }}
                            </span>
                        </button>
                    <div class="dg-clear"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<style scoped>
.page-loading-indicator {
    text-align: center;
    position: relative;
    padding-top: 10px!important;
}
.page-loading-indicator > img {
    width: 80px;
}
.loading-message {
    margin-top: 20px;
    color: #000;
    font-size: 16px;
}
.dialog-container{
    top: 150px!important;
}
.dg-title {
    text-align: center;
}
.dg-content {
    padding: 35px 20px;
    margin: 20px 0 0;
    border-radius: 5px;
    border: #007297 1px solid;
    box-shadow: 2px 5px 5.5px 0px rgb(0 0 0 / 40%)
}
.dg-content-footer {
    overflow: auto;
    position: relative;
    padding: 15px 0 0;
    text-align: left !important;
}
.dg-content-body {
    border-bottom: 1px solid #E1E6EA;
}
.card-body {
    background-color: #961F23;
    border-radius: 20px;
    color: white !important;
}
.info-row {
    display: flex;
    justify-content: space-between;
    gap: 15px;
    margin-top: 30px;
    font-weight: bold;
    line-height: 1.2;
    text-transform: uppercase;
}
@media (max-width: 400px) {
    .info-row {
        font-size: 14px;
    }
}
.name {
    word-wrap: break-word;
}

@media (min-width: 410px) {
    .name {
        max-width: 225px;
    }
}
@media (max-width: 410px) {
    .name {
        max-width: 175px;
    }
}
@media (max-width: 360px) {
    .name {
        max-width: 135px !important;
    }
}
.label {
    text-transform: none;
    font-weight: normal;
    font-size: 0.6em !important;
}
.cardNumber {
    font-size: 20px;
    clear: both;
    padding-top: 20px;
}
.cardNumber span.hidden-number {
    vertical-align: text-bottom;
    font-size: 14px;
}
.card-icon {
    font-size: 30px;
    vertical-align: text-top;
    float: right;
}
</style>

<script>
import { mapActions, mapGetters } from 'vuex';
import Utils from '../../../js/helpers/Utils';

export default {
    props: {
        csOrderNo: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            loadingIndicator: true,
            dialogEnabled: true,
            eowp: {
                subscriptionInfo: {
                    year: '',
                    month: '',
                    name: '',
                    type: '',
                    refId: ''
                },
                infoRequestType: {
                    SUBSCRIPTION_INFO_REQUEST: 1
                },
                cardBrandIcon: {
                    'visa': 'fa-cc-visa',
                    'mastercard': 'fa-cc-mastercard',
                    'discover': 'fa-cc-discover',
                    'amex': 'fa-cc-amex',
                    'jcb': 'fa-cc-jcb',
                    'diners': 'fa-cc-diners-club',
                    'default': 'fa-credit-card'
                },
            },
            dialogParams: {
                loadingDialog: {
                    message: 'Stripeからカード情報を取得する。' // Getting card information from Stripe
                },
                cardInfoDialog: {
                    title: '現在ご利用中のカード情報', // Card Information
                    label: {
                        name: 'NAME: ',
                        expiry: 'GOOD THRU: ',
                    },
                    closeText: '閉じる' // Close
                },
                refreshPageNetworkErrorOptions: {
                    loader: false,
                    okText: '閉じる', //Close
                    cancelText: '閉じる', //Close
                    animation: 'zoom',
                    backdropClose: true
                }
            }
        };
    },
    async created() {
        this.clearCardInfoValues();
        let minimumDelayInMillis = 1500;
        let timeStart = (new Date()).getTime();
        await this.getSubscriptionInfo({
            userId: this.sessionDetails.userId, 
            sessionId: this.sessionDetails.sessionId,
            csOrderNo: this.csOrderNo, 
            infoRequestType: this.eowp.infoRequestType.SUBSCRIPTION_INFO_REQUEST
        }).then(res => {
            // if loading screen dialog was closed while request is ongoing, 
            // we will clear subscription_info state values after the request
            if(!this.dialogEnabled) {
                this.clearCardInfoValues(); 
                return;
            }
            // if request is not interrupted, proceed on displaying success/error response
            if(res.status_code != 'SUCCESS') {
                this.closeDialog();
                this.$dialog.alert({
                    title: "エラーが発生しました", //An Error Occurred
                    body: "お客様のカード情報の取得に失敗しました。 [StatusCode: " + res.status_code + "]" //Failed to retrieve card information
                }, this.dialogParams.refreshPageNetworkErrorOptions)
                .then(() => {})
                return;
            } else {
                let timeSpent = (new Date()).getTime() - timeStart;
                let delay = timeSpent < minimumDelayInMillis ? (minimumDelayInMillis - timeSpent) : 0;
                setTimeout(() => this.loadingIndicator = false, delay); // Control displaying on info with a minimum delay
                this.eowp.subscriptionInfo.month = res.records.month.toString().padStart(2, '0'); // append 0 if < 10
                this.eowp.subscriptionInfo.year = res.records.year;
                this.eowp.subscriptionInfo.type = res.records.type;
                this.eowp.subscriptionInfo.refId = res.records.refId;
                this.eowp.subscriptionInfo.name = res.records.name;
            }
        })
    }, 
    computed: {
        ...mapGetters({
            sessionDetails: 'user/session_details',
        })
    },
    methods: {
        ...mapActions({
            getSubscriptionInfo: 'ssr/getSubscriptionInfo',
            clearSubscriptionInfo: 'ssr/clearSubscriptionInfo'
        }),
        closeDialog() {
            this.$emit('close', true);
            this.loadingIndicator = true;
            this.dialogEnabled = false;
            this.clearCardInfoValues();
        },
        getCardBrandIcon(brand) {
            let icon = !Utils.isEmpty(this.eowp.cardBrandIcon[brand]) ? this.eowp.cardBrandIcon[brand] : this.eowp.cardBrandIcon['default'];
            return "card-icon " + icon;
        },
        clearCardInfoValues() {
            this.clearSubscriptionInfo();
            this.eowp.subscriptionInfo.month = '';
            this.eowp.subscriptionInfo.year =  '';
            this.eowp.subscriptionInfo.type = '';
            this.eowp.subscriptionInfo.refId = '';
            this.eowp.subscriptionInfo.name = '';
        }
    }
}

</script>

